module.exports = __webpack_public_path__ + "img/ToonBlast.bc8fc692.webp";